export default Object.freeze({
  SUCCESS: {
    OK: {
      CODE: 200,
    },
  },
  ERROR: {
    BAD_REQUEST: {
      CODE: 400,
    },
    UNAUTHORIZED: {
      CODE: 401,
    },
    PAYMENT_REQUIRED: {
      CODE: 402,
    },
    FORBIDDEN: {
      CODE: 403,
    },
    NOT_FOUND: {
      CODE: 404,
    },
    REQUEST_TIMEOUT: {
      CODE: 408,
    },

    INTERNAL_SERVER_ERROR: {
      CODE: 500,
      MSG: 'Something went wrong',
    },
    BAD_GATEWAY: {
      CODE: 502,
    },
    SERVICE_UNAVAILABLE: {
      CODE: 503,
    },
    GATEWAY_TIMEOUT: {
      CODE: 504,
    },

    ALREADY_EXISTS: {
      CODE: 606,
    },
    VALIDATION_ERROR: {
      CODE: 607,
    },
  },
});
